var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('notifications',{attrs:{"position":"bottom center","classes":"notify"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }